export const DATENSCHUTZ_LINK_JOBS = '/jobs/privacy-policy';
export const DATENSCHUTZ_LINK_JOBS_EN = '/jobs/privacy-policy-en';
